import { useEffect, useRef } from 'react';

function useClickOutside(ref, callback, ignoreRefs = []) {
  const callbackRef = useRef(callback);
  const ignoreRefsRef = useRef(ignoreRefs);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    ignoreRefsRef.current = ignoreRefs;
  }, [ignoreRefs]);

  useEffect(() => {
    function handleClickOutside(event) {
      const isClickInsideAntModal = event.target.closest('.ant-modal-wrap, .ant-modal-mask');

      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        !ignoreRefsRef.current.some(
          (ignoreRef) => ignoreRef.current && ignoreRef.current.contains(event.target)
        ) &&
        !isClickInsideAntModal
      ) {
        callbackRef.current();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export default useClickOutside;
